import { render, staticRenderFns } from "./AdminCommissionRates.vue?vue&type=template&id=daa70cd2&scoped=true&"
import script from "./AdminCommissionRates.vue?vue&type=script&lang=js&"
export * from "./AdminCommissionRates.vue?vue&type=script&lang=js&"
import style0 from "./AdminCommissionRates.vue?vue&type=style&index=0&id=daa70cd2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "daa70cd2",
  null
  
)

export default component.exports